export const environment = {
	production: false,
	appFisca: "https://fisca-dev.milicencimedica.cl/",
	apiFisca: "https://api.fisca-dev.milicenciamedica.cl/",
	fiscaRecSesion: "fisca-dev-rec-sesion",
	client_id: "5f7fhrqstg7tf7n1llev681cuu",
	oauthTokenUrl: "https://api.fisca-dev.milicenciamedica.cl/fisca-dev-token",
	logout: "fisca-dev-logout",
	extenderSesion: "fisca-dev-extender-sesion-db",
	verificarSesion: "fisca-dev-verificar-sesion",
	env: "fisca-dev",
  envUriApi: true,
	client_id_cu: "2tbak11888ci4575jufhlfjop3",
};